module.exports = __webpack_public_path__ + "img/mechanical_engineer_stats.8bc300a1.png";